import { useEffect, useState } from 'react';
import { container } from '@/di';
import { TYPES } from '@/di/tokens';
import { ListPanelPagosAction } from '@/application/actions';
import { PanelPago } from '@/domain/entities/PanelPago';
import type { PanelPagoFilters } from '@/domain/repositories/IPanelPagoRepository';

export const usePanelPagos = (filters?: PanelPagoFilters) => {
  const [pagos, setPagos] = useState<PanelPago[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const loadPagos = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const action = container.get<ListPanelPagosAction>(TYPES.ListPanelPagosAction);
      const result = await action.execute(filters);
      setPagos(result);
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Failed to load payments');
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadPagos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters?.anio, filters?.mes, filters?.estadoPagoId]);

  return { pagos, isLoading, error, refetch: loadPagos };
};
